// Návrat klientky (mockup „Návrat klientky“, schváleno 2. 10. 2026).
// Od 2. 10. 2026 (mockup „Výběr termínu na měsíc“) se v hovoru domluví i první trénink:
// měsíční kalendář ukáže jen dny, kdy má trenér vybraný čas volný. Po zapsání se klientce
// změní trenér a lokalita, trenér dostane zprávu do Slacku a klientka e-mail a SMS.
// Kontakt, který u nás byl (Přerušeno nebo Ukončeno), se vrací. Nejdřív volba (Láďa 2. 10.):
// se zkušebním tréninkem (otevře se běžný hovor, vše jako vždy), nebo bez zkušebního, rovnou
// balíček: kolikrát týdně a pravidelný čas u trenéra, po Zapsat návrat jde předrezervace do
// rozvrhu, zpráva Kristině do #operations-company (Aktivní, fakturace) a záznam do historie.
import React, { useEffect, useMemo, useState } from "react";
import { PhoneIncoming, ChevronLeft, ChevronRight, CircleCheck, CheckCircle2, Check, AlertTriangle, Package, CalendarPlus, CalendarCheck2, CalendarDays } from "lucide-react";
import { Modal, HlavickaOkna } from "../ui.jsx";
import { salesGet, salesPost, dowOf, casBezNuly } from "./salesApi.js";
import { Oznameni, Cipy, CastKroku, CoRict, Pil } from "./salesUi.jsx";
import { PredbeznaNabidka } from "./HovorPruvodce.jsx";
import MesicniKalendar, { denSlovy, veDnSlovy, volnychText } from "./MesicniKalendar.jsx";

const KAZDY = ["", "každé pondělí", "každé úterý", "každou středu", "každý čtvrtek", "každý pátek", "každou sobotu", "každou neděli"];
const hodina = (h) => `${String(h).padStart(2, "0")}:00`;

// 3. krok: den a čas prvního tréninku. Kalendář ukazuje dny, kdy má trenér volno. U dne,
// kdy je volný pravidelný čas, je ten čas napsaný, u ostatních počet volných časů.
// Po klepnutí na den jsou vpravo všechny volné časy trenéra (jako u zkušebního),
// pravidelný čas je rovnou vybraný, první trénink ale může být i jindy (Láďa 2. 10. 2026).
// 18. 10. 2026: používá i Deal u trenéra (DealDialogy.jsx), termíny pak bere z /api/deal-trener (prop nacti).
export function PrvniTrenink({ predbezne, lokalita, value, onChange, onPobocka, nacti = null }) {
  const [mesic, setMesic] = useState(() => String(value?.datum || "").slice(0, 7) || new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  const [nacitam, setNacitam] = useState(false);
  const [chyba, setChyba] = useState("");
  const [den, setDen] = useState(value?.datum || "");
  const casy = predbezne.casy || [];
  const put = predbezne.putujici;
  const klicVyberu = `${predbezne.trener_id}|${casy.map((c) => `${c.dow}-${c.hod}`).join(",")}|${put ? put.okno : ""}`;

  useEffect(() => {
    if (!predbezne.trener_id) { setData(null); return undefined; }
    let zr = false;
    setNacitam(true); setChyba("");
    (nacti ? nacti({ mesic }) : salesGet("terminy", { mesic, lokalita, trener: predbezne.trener_id, typ: "osobni", odpoledne: put?.okno === "odpoledne" ? "1" : "" }))
      .then((d) => { if (zr) return; setData(d); if (d.mesic !== mesic) setMesic(d.mesic); const p = (d.lokality || []).find((l) => l.kod === d.lokalita); if (p) onPobocka?.(p.nazev); })
      .catch((e) => !zr && setChyba(e.message))
      .finally(() => !zr && setNacitam(false));
    return () => { zr = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mesic, lokalita, predbezne.trener_id, put?.okno]);
  // Jiný trenér nebo čas: vybraný první trénink už neplatí.
  useEffect(() => { onChange(null); setDen(""); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [klicVyberu]);

  const slotyDne = (datum) => {
    const s = (data?.sloty?.[datum] || []).filter((x) => String(x.trener_id) === String(predbezne.trener_id));
    return put ? s.filter((x) => (put.okno === "dopoledne" ? x.cas < "12:00" : x.cas >= "12:00")) : s;
  };
  // Pravidelný čas v daný den, když je u trenéra volný.
  const pravidelnyDne = (datum) => {
    const c = casy.find((x) => Number(x.dow) === dowOf(datum));
    return c && slotyDne(datum).some((s) => s.cas === hodina(c.hod)) ? hodina(c.hod) : null;
  };
  const popisDne = (d) => {
    const n = slotyDne(d.datum).length;
    if (!n) return { dostupny: false, text: casy.some((x) => Number(x.dow) === d.dow) ? "plno" : "", ton: "plno" };
    const c = pravidelnyDne(d.datum);
    if (c) return { dostupny: true, text: casBezNuly(c), ton: d.svatek ? "svatek" : "volno" };
    return { dostupny: true, text: volnychText(n), kratce: String(n), ton: d.svatek ? "svatek" : "plno" };
  };
  const vyberDen = (datum) => {
    setDen(datum);
    const c = pravidelnyDne(datum);
    onChange(c ? { datum, cas: c } : null);
  };
  const sloty = useMemo(() => (den ? slotyDne(den) : []), [den, data]); // eslint-disable-line react-hooks/exhaustive-deps
  const pravidelny = den ? pravidelnyDne(den) : null;
  const jinyNezPravidelny = value?.cas && casy.length && !casy.some((c) => Number(c.dow) === dowOf(value.datum) && hodina(c.hod) === value.cas);

  if (!predbezne.trener_id) return <Oznameni ton="info">Nejdřív vyber trenéra a pravidelný čas, pak tady uvidíš dny, kdy může začít.</Oznameni>;
  return (
    <div className="space-y-3">
      {chyba && <Oznameni ton="problem">{chyba}</Oznameni>}
      <div className="grid gap-4 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)]">
        <div className={nacitam && data ? "opacity-70" : ""} aria-busy={nacitam}>
          <MesicniKalendar data={data} mesic={mesic} onMesic={setMesic} vybrany={den} onVyber={vyberDen} popisDne={popisDne} nacitam={nacitam} />
        </div>
        <div className="space-y-3">
          {den ? (
            <>
              <div className="flex flex-wrap items-center gap-2 rounded-xl bg-brand-100 px-3 py-2.5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white text-brand-deep"><CalendarDays className="h-[18px] w-[18px]" /></span>
                <span className="min-w-0 flex-1 basis-[calc(100%-3rem)] text-[17px] font-bold text-brand-950 sm:basis-0">{denSlovy(den)}</span>
                <span className="rounded-full bg-white px-2.5 py-1 text-[12px] font-bold text-brand-deep">{volnychText(sloty.length)}</span>
                <span className="rounded-full bg-white px-2.5 py-1 text-[12px] font-bold text-brand-deep">60 minut</span>
              </div>
              <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-1">
                {sloty.map((s) => {
                  const zap = value?.datum === den && value?.cas === s.cas;
                  return (
                    <button key={s.cas} type="button" onClick={() => onChange({ datum: den, cas: s.cas })} aria-pressed={zap}
                      className={`flex min-h-[56px] items-center gap-3 rounded-xl border px-3.5 py-2 text-left ${zap ? "border-2 border-brand bg-brand-50" : "border-slate-200 bg-white"}`}>
                      <span className="w-14 text-lg font-bold tabular-nums text-slate-900">{casBezNuly(s.cas)}</span>
                      <span className="min-w-0 flex-1 lg:flex lg:flex-wrap lg:items-center lg:gap-x-3">
                        <span className="flex flex-wrap items-center gap-1.5 text-[15px] font-bold text-slate-900">{predbezne.trener}{s.cas === pravidelny && <Pil ton="znacka" casti="pravidelný čas" mala />}</span>
                        <span className="block text-[13px] tabular-nums text-slate-500">{casBezNuly(s.cas)} až {casBezNuly(s.konec)}</span>
                      </span>
                      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 ${zap ? "border-brand bg-brand text-white" : "border-slate-300"}`}>{zap && <Check className="h-3.5 w-3.5" />}</span>
                    </button>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="text-[13px] leading-snug text-slate-500">
              {put ? "U dne je počet volných časů trenéra. Klepni na den a vyber čas prvního tréninku." : casy.length ? "U dne, kdy má trenér pravidelný čas volný, je ten čas napsaný. U ostatních dnů je počet volných časů. Klepni na den a vpravo uvidíš všechny volné časy." : "U dne je počet volných časů. Klepni na den a vpravo uvidíš všechny volné časy."}
            </div>
          )}
          {value?.datum && value?.cas && (
            <div className="flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-emerald-700"><CalendarCheck2 className="h-5 w-5" /></span>
              <span className="min-w-0">
                <span className="block text-[18px] font-bold leading-snug text-emerald-900 sm:text-[20px]">Od {denSlovy(value.datum, false).replace(/^(\S+)/, (x) => GEN_DNE[x] || x)} v {casBezNuly(value.cas)}</span>
                <span className="block text-[14px] text-emerald-800">{put ? `dál ${put.frekvence || 1}x týdně ${put.okno}, ` : casy.length ? `${jinyNezPravidelny ? "dál " : ""}${casy.map((c) => `${KAZDY[c.dow]} v ${c.hod}:00`).join(" a ")}, ` : ""}trenér {predbezne.trener}</span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
const GEN_DNE = { "pondělí": "pondělí", "úterý": "úterý", "středa": "středy", "čtvrtek": "čtvrtka", "pátek": "pátku", "sobota": "soboty", "neděle": "neděle" };

const FREKVENCE = ["1x", "2x", "3x"];
const normFrekvence = (t) => { const m = String(t || "").match(/[123]/); return m ? `${m[0]}x` : ""; };

function vychoziStav(k) {
  const d = k.dotaznik || {};
  return {
    dotaznik: { frekvence: normFrekvence(k.klientka?.frekvence) || normFrekvence(d.frekvence), kdy_muze: d.kdy_muze || "" },
    predbezne: { trener_id: "", trener: "", casy: [], putujici: null },
  };
}

export default function NavratDialog({ kontakt, open, onClose, onHotovo, onSeZkusebnim }) {
  const kl = kontakt.klientka || {};
  const [stav, setStav] = useState(() => vychoziStav(kontakt));
  const [poznamka, setPoznamka] = useState("");
  const [chyba, setChyba] = useState("");
  const [busy, setBusy] = useState(false);
  const [vysledek, setVysledek] = useState(null);
  const [volba, setVolba] = useState(null); // null | bez
  const [prvni, setPrvni] = useState(null);
  const [pobocka, setPobocka] = useState("");
  const p = stav.predbezne;
  const vybrano = !!(p.trener_id && ((p.casy || []).length || p.putujici));
  // Stará pobočka už nefunguje (lokalita_kod chybí jen u neaktivní pobočky).
  const zrusenaPobocka = !!(kl.lokalita && !kl.lokalita_kod);

  // 6. 10. 2026 (Láďa): blbuvzdorné. Tlačítko jde zmáčknout, až když je hotové všechno,
  // do té doby u něj stojí, co chybí. Chyba ze serveru se ukáže u tlačítka, ne nahoře.
  const chybi = [
    !stav.dotaznik.frekvence && "kolikrát týdně (krok 1)",
    !vybrano && "pravidelný čas nebo Putující (krok 2)",
    !(prvni?.datum && prvni?.cas) && "první trénink v kalendáři (krok 3)",
  ].filter(Boolean);
  const zapsat = async () => {
    if (chybi.length) { setChyba(`Ještě chybí: ${chybi.join(", ")}.`); return; }
    setBusy(true); setChyba("");
    try {
      const r = await salesPost("navrat", { id: kontakt.id, predbezne: p, frekvence: stav.dotaznik.frekvence, poznamka, prvni });
      setVysledek(r);
      onHotovo?.(r);
    } catch (e) { setChyba(`${e.message} Zkus to ještě jednou, když to nepůjde, napiš Láďovi.`); } finally { setBusy(false); }
  };

  const patka = vysledek
    ? <button type="button" className="btn-primary" onClick={onClose}>Zpět na Plán</button>
    : !volba
      ? <button type="button" className="btn-secondary" onClick={onClose}><ChevronLeft className="h-4 w-4" />Zavřít</button>
      : <>
        {/* 6. 10. 2026: chyba u tlačítka, ne nahoře v dlouhém okně, kde ji sales neviděla
            („Zapsat návrat“ se zdánlivě nedělo nic). */}
        {chyba && <div className="basis-full"><Oznameni ton="problem">{chyba}</Oznameni></div>}
        {!chyba && chybi.length > 0 && <div className="basis-full text-[13px] font-semibold text-slate-500">Ještě chybí: {chybi.join(", ")}.</div>}
        <button type="button" className="btn-secondary" onClick={() => { setVolba(null); setChyba(""); }}><ChevronLeft className="h-4 w-4" />Zpět</button>
        <button type="button" className="btn bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50" onClick={zapsat} disabled={busy || chybi.length > 0} aria-busy={busy} title={chybi.length ? `Ještě chybí: ${chybi.join(", ")}` : undefined}><CircleCheck className="h-4 w-4" />{busy ? "Zapisuju…" : "Zapsat návrat"}</button>
      </>;

  return (
    <Modal open={open} onClose={onClose} size="lg" plne plnaHlavicka
      header={<HlavickaOkna ikona={PhoneIncoming} nazev="Návrat klientky" popis={`${kontakt.jmeno}${kontakt.telefon ? `, ${kontakt.telefon}` : ""}`} onClose={onClose} />}
      footer={patka}>
      {vysledek ? (
        <div className="space-y-4 py-2 text-center">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-50"><CheckCircle2 className="h-10 w-10 text-emerald-600" /></span>
          <div className="font-serif text-2xl font-bold text-slate-900">Návrat zapsaný</div>
          <div className="text-[16px] text-slate-600"><b className="text-slate-900">{kontakt.jmeno}</b>, trenér <b className="text-slate-900">{vysledek.trener}</b>{vysledek.pravidelne ? <>, <b className="text-slate-900">{vysledek.pravidelne}</b></> : null}</div>
          {vysledek.prvni && <div className="text-[16px] text-slate-600">První trénink <b className="text-slate-900">{denSlovy(vysledek.prvni.datum, false)} v {casBezNuly(vysledek.prvni.cas)}</b>{vysledek.lokalita ? <>, {vysledek.lokalita}</> : null}</div>}
          <div className="mx-auto max-w-md space-y-2 rounded-2xl border border-slate-200 bg-white p-4 text-left">
            {(vysledek.kroky || []).filter((x) => x.text).map((x, i) => (
              <div key={i} className="flex items-start gap-2.5 text-[15px] text-slate-800">
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${x.ok ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{x.ok ? <Check className="h-3.5 w-3.5" /> : <AlertTriangle className="h-3.5 w-3.5" />}</span>
                <span>{x.text}{!x.ok && x.chyba ? <span className="block text-[13px] text-rose-700">{x.chyba}</span> : null}</span>
              </div>
            ))}
          </div>
          {(vysledek.kroky || []).some((x) => !x.ok) && <Oznameni ton="pozor">Něco neprošlo, návrat je ale zapsaný. Napiš prosím Láďovi, co je červeně.</Oznameni>}
        </div>
      ) : !volba ? (
        <div className="space-y-3">
          <div className="text-[15px] font-bold text-slate-900">Jak se vrací?</div>
          <button type="button" onClick={() => setVolba("bez")}
            className="flex min-h-[72px] w-full items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3.5 text-left shadow-glass transition hover:border-brand/50 active:bg-brand-light/60">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700"><Package className="h-5 w-5" /></span>
            <span className="min-w-0 flex-1"><span className="block text-[16px] font-bold text-slate-900">Bez zkušebního, rovnou balíček</span>
              <span className="block text-[13px] leading-snug text-slate-500">Vybereš pravidelný čas u trenéra a den prvního tréninku. Trenér, klientka i Kristina dostanou zprávu.</span></span>
            <ChevronRight className="h-5 w-5 shrink-0 text-slate-400" />
          </button>
          <button type="button" onClick={() => onSeZkusebnim?.()}
            className="flex min-h-[72px] w-full items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3.5 text-left shadow-glass transition hover:border-brand/50 active:bg-brand-light/60">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-deep"><CalendarPlus className="h-5 w-5" /></span>
            <span className="min-w-0 flex-1"><span className="block text-[16px] font-bold text-slate-900">Se zkušebním tréninkem</span>
              <span className="block text-[13px] leading-snug text-slate-500">Otevře se běžný hovor: dotazník, termín zkušebního, faktura, vše jako vždy.</span></span>
            <ChevronRight className="h-5 w-5 shrink-0 text-slate-400" />
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {zrusenaPobocka && (
            <Oznameni ton="pozor"><b>Dřív chodila: {kl.lokalita}{kl.trener ? `, trenér ${kl.trener}` : ""}.</b> Ta pobočka už nefunguje, proto nabízím trenéry {pobocka ? `z ${pobocka}` : "z aktivní pobočky"}. Vyber nového trenéra, po zapsání návratu se klientce změní trenér i lokalita.</Oznameni>
          )}
          <Oznameni ton="info"><b>Po klepnutí na Zapsat návrat:</b> první trénink se zapíše trenérovi do kalendáře a pravidelný čas do rozvrhu jako předrezervace. Klientce se nastaví nový trenér a lokalita, trenér dostane zprávu do Slacku, klientka e‑mail a SMS a Kristina zprávu, ať ji dá Aktivní a znovu spustí fakturaci. Zkušební trénink se nedomlouvá.</Oznameni>
          <CastKroku cislo={1} nazev="Kolikrát týdně" hotovo={!!stav.dotaznik.frekvence}>
            <div className="text-[13px] text-slate-600">{kl.frekvence ? `Dřív chodila ${kl.frekvence}${kl.trener ? ` k trenérovi ${kl.trener}` : ""}.` : "Zeptej se, kolikrát týdně chce chodit."}</div>
            <Cipy moznosti={FREKVENCE} value={stav.dotaznik.frekvence} onChange={(v) => setStav((s) => ({ ...s, dotaznik: { ...s.dotaznik, frekvence: v }, predbezne: { ...s.predbezne, casy: [], putujici: null } }))} />
          </CastKroku>
          <PredbeznaNabidka stav={stav} setStav={setStav} cislo={2} nazev="Vyber nový pravidelný čas" popisZdroje="Vybráno:"
            lokalita={kl.lokalita_kod} vychoziTrenerId={kl.trener_id} bezVolnaText="Zkus druhou část dne, nebo jí zavolej jindy." />
          <CastKroku cislo={3} nazev="Od kdy začne (první trénink)" hotovo={!!(prvni?.datum && prvni?.cas)}>
            {prvni?.datum && prvni?.cas && (
              <CoRict>Takže začneme <b>{veDnSlovy(prvni.datum)} v {casBezNuly(prvni.cas)}</b>{p.trener ? <>, trénovat vás bude <b>{p.trener}</b></> : null}. Vyhovuje vám to? Na prvním tréninku si spolu domluvíte další termíny. Všechno vám pošlu e‑mailem i SMS.</CoRict>
            )}
            <PrvniTrenink predbezne={p} lokalita={kl.lokalita_kod} value={prvni} onChange={setPrvni} onPobocka={setPobocka} />
          </CastKroku>
          <CastKroku cislo={4} nazev="Poznámka pro trenéra a Kristinu" hotovo={!!poznamka.trim()}>
            <textarea className="field min-h-[88px]" value={poznamka} onChange={(e) => setPoznamka(e.target.value)} maxLength={500}
              placeholder="Nepovinné. Třeba od kdy chce začít, jaký balíček, co se změnilo." />
          </CastKroku>
        </div>
      )}
    </Modal>
  );
}
